import {
  PERSONA_DATA_FAIL,
  PERSONA_DATA_REQUEST,
  PERSONA_DATA_SUCCESS,
  SET_INQUIRY_ID,
  SET_OTP_PROOF_TOKEN,
} from "../types/actionTypes";

const personaDataReducer = (state={},action:any) => {
    switch (action.type) {
        case PERSONA_DATA_REQUEST:
          return { ...state, loading: true };
        case PERSONA_DATA_SUCCESS:
          return { ...state, loading: false, fields: action.payload };
        case PERSONA_DATA_FAIL:
          return { ...state, loading: false, error: action.payload };
        case SET_OTP_PROOF_TOKEN:
          return { ...state, otpProofToken: action.payload };
        case SET_INQUIRY_ID:
          return { ...state, inquiryId: action.payload };
        default:
          return state;
      }
}

export default personaDataReducer
